// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicContactDetailsSection_container___tKzA","names":"BasicContactDetailsSection_names__3Htrp"};